import { uiText } from '../../../utils/uiTranslation';
import React from 'react';

export const field = (label, value, fullWidth = false) => (
  <div style={{ marginBottom: 16, gridColumn: fullWidth ? 'span 2' : 'auto' }}>
    <div style={{ 
      fontFamily: 'Montserrat', 
      fontSize: '12px', 
      fontWeight: 600,
      opacity: 0.7, 
      color: 'var(--app-text, #FFFFFF)',
      marginBottom: 4,
      textTransform: 'none',
      letterSpacing: '0.5px'
    }}>{uiText(label)}</div>
    <div style={{ 
      fontFamily: 'Montserrat',
      fontSize: '16px',
      color: 'var(--app-text, #FFFFFF)'
    }}>{value || '—'}</div>
  </div>
);

export const sectionTitle = (icon, title) => (
  <div style={{ 
    display: 'flex', 
    alignItems: 'center', 
    gap: '10px',
    marginTop: 32,
    marginBottom: 20,
    paddingBottom: 12,
    borderBottom: "1px solid var(--app-border, rgba(86, 141, 237, 0.2))"
  }}>
    <i className={icon} style={{ color: '#568ded', fontSize: '18px' }}></i>
    <h3 style={{ 
      margin: 0, 
      fontFamily: 'Montserrat',
      fontSize: '18px',
      fontWeight: "var(--app-weight-strong, 700)",
      color: 'var(--app-text, #FFFFFF)'
    }}>{title}</h3>
  </div>
);





